import lozad from 'lozad'
import { header } from '../index/scripts/header';
import { ajaxLoadMore } from '../index/scripts/ajaxLoadMore';
$(document).ready(function () {
	header.init();
	ajaxLoadMore.init();
})
/*==================== Workflow  ====================*/

/*==================== Lazyload JS ====================*/
const observer = lozad() // lazy loads elements with default selector as '.lozad'
observer.observe()
